import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDyl9Eji474mAlfVvYzw1zOwjrPhy94Bao",
  authDomain: "uniform-2nd-hand.firebaseapp.com",
  projectId: "uniform-2nd-hand",
  storageBucket: "uniform-2nd-hand.appspot.com",
  messagingSenderId: "1006985388173",
  appId: "1:1006985388173:web:c79493f64719f4233742c4"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
